import { API } from './../api/api'
import { fetch, post } from './../api/httpClient'
import localStorageService from './../api/localStorageService'
import {
  DISTRICT_ADMIN,
  MESSAGE_SEVERITIES,
  REGISTRAR,
  ROLE_KINDS,
  ROOT,
  ROUTE,
  THEME,
} from './../helpers/constants'
import PERMISSIONS from './../helpers/permissions'
import { selectApp } from './../helpers/selectors'
import {
  applySchoolTheme,
  get,
  getAccountDataFromToken,
  getTokenFromUrl,
  isEmpty,
  isUnauthRoute,
  set,
} from './../helpers/utils'
import ActionTypes from './actionTypes'
import { messageAction } from './app.action'
import { setBasics, setStorageListner } from './token.action'
import { userAction } from './user.action'

export const authAction = (data) => (dispatch) =>
  dispatch({
    type: ActionTypes.LOGIN,
    data,
  })

const checkForPermission = (data, keys) => {
  if (data.isAdmin) {
    return true
  }
  const allowedActions = data?.permissions?.allowedActions || {}
  return Object.keys(allowedActions).some(
    (action) =>
      !isEmpty(
        (allowedActions[action]?.list || []).find((permission) => {
          return keys.includes(permission)
        })
      )
  )
}

const checkForRole = (data, keys) => {
  if (data.isAdmin) {
    return true
  }
  const roles = data?.roles || []
  return roles.some((role) => keys.includes(role.name))
}

export const introspectCall = () => async (dispatch, getState) => {
  try {
    const url = API.AGM2.INTROSPECT
    const { data } = await fetch(url)
    const isAdmin = !isEmpty(
      (data.roles || []).find((role) => role.name === ROOT && role.kind === ROLE_KINDS.SYSTEM)
    )
    let userTheme = get(data, 'user_principal.attributes.user_theme[0]', '')
    if (!userTheme) {
      userTheme = THEME.LIGHT
      set(data, 'user_principal.attributes.user_theme[0]', userTheme)
    }
    localStorageService.setTheme(userTheme)
    applySchoolTheme(userTheme)
    dispatch(authAction({ isLoggedIn: true }))
    dispatch(
      userAction({
        ...data,
        isAdmin,
        //--------------------------------------------UI MENU-----------------------------------------------------//
        showMenuDashboard: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Dashboard']]),
        showMenuLibraryManagement:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/LibraryManagement']]),
        showMenuExecutiveSummary:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/ExecutiveSummary']]),
        showMenuUsers: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Users']]),
        showMenuDistrict: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/District']]),
        showMenuSchool: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/School']]),
        showMenuApplicationLogs:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/ApplicationLogs']]),
        showMenuEmailLogs: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/EmailLogs']]),
        showMenuTemplates: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Templates']]),
        showMenuRoles: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Roles']]),
        showMenuEmailSetting:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/EmailSetting']]),
        showMenuStudent: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Student']]),
        showMenuCourse: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Course']]),
        showMenuProgram: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Program']]),
        showMenuTranscript:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Transcript']]),
        showMenuEnrollment:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Enrollment']]),
        showReEnrollment:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListReEnrollment']]),
        showMenuMasterReport:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/MasterReport']]),
        showMenuDailyReport:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/DailyReport']]),
        showMenuInactivityReport:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/InactivityReport']]),
        showMenuGraduateReport:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/GraduateReport']]),
        showMenuIncompleteEnrollmentReport:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/IncompleteEnrollmentReport']]),
        showMenuCustomReport:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/CustomReport']]),
        showMenuTransaction:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Transaction']]),
        showMenuExport: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Export']]),
        showMenuCalendar: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Calendar']]),
        showMenuHelpDesk: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/HelpDesk']]),
        showMenuInvoice: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Invoice']]),
        showMenuLms: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Lms']]),
        showMenuSubject: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Subject']]),
        showMenuSuccesscoach:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Successcoach']]),
        showMenuAffiliates:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Affiliates']]),
        isApplicationListAllowed:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListStudent']]),
        isEnrollmentListAllowed:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListEnrollment']]),
        isDropEnrollmentListAllowed:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListDropEnrollment']]),
        isReEnrollmentListAllowed:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListReEnrollment']]),
        isTransactionListAllowed:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListTransaction']]),
        isInactivityListAllowed:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListInactiveReport']]),
        isProgramListAllowed: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListProgram']]),
        isCourseListAllowed: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListCourse']]),
        isSMSListAllowed: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListSMS']]),
        isSMSReadAllowed: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ReadSMS']]),
        isSMSUpdateAllowed: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/UpdateSMS']]),
        isSMSCreateAllowed: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/CreateSMS']]),
        isSchoolListAllowed: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListSchool']]),
        isListDailyReportAllowed:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListDailyReport']]),
        isTranscriptAllowed:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListTranscriptTemplate']]),
        isDashboardListAllowed:
          isAdmin || checkForPermission(data, [PERMISSIONS['DASHBOARD/ListDashboard']]),
        isVoucherList: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListVoucher']]),
        isVoucherRead: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ReadVoucher']]),
        isVoucherCreate: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/CreateVoucher']]),
        isVoucherUpdate: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/UpdateVoucher']]),
        isVoucherDelete: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/DeleteVoucher']]),
        isVoucherApply: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ApplyVoucher']]),
        isreadModelExtensions:
          isAdmin || checkForPermission(data, [PERMISSIONS['EasyGrader/ReadModelExtensions']]),
        isManageModelExtensions:
          isAdmin || checkForPermission(data, [PERMISSIONS['EasyGrader/UpdateModelExtensions']]),
        isNoteCreateAllowed:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/CreateStudentNote']]),
        isNoteListAllowed:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListStudentNote']]),
        isNoteReadAllowed:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ReadStudentNote']]),
        isNoteUpdateAllowed:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/UpdateStudentNote']]),
        isNoteDeleteAllowed:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/DeleteStudentNote']]),
        showCancelPaymentButton:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/CancelPayment']]),
        showUpdateInvoiceButton:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/UpdateInvoice']]),
        showSettleBalanceButton:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/InvoiceBalanceSettle']]),
        showUpdateBillingCycleButton:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/UpdateBillingCycle']]),
        isRegistrarPermission: isAdmin || checkForRole(data, [REGISTRAR, DISTRICT_ADMIN]),
        showMenuEasyGrader:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Easygrader']]),
        showMenuEasyGraderBenchmark: true,
        showMenuModelExtensions: true,
        // showMenuEasyGraderBenchmark:
        //   isAdmin || checkForPermission(data, [PERMISSIONS['SIS/Menu/Benchmark']]),
        createSchoolAdditionalFee:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/CreateAdditionalFeeConfig']]),
        listSchoolAdditionalFee:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ListAdditionalFeeConfig']]),
        updateSchoolAdditionalFee:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/UpdateAdditionalFeeConfig']]),
        deleteSchoolAdditionalFee:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/DeleteAdditionalFeeConfig']]),
        readSchoolAdditionalFee:
          isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ReadAdditionalFeeConfig']]),
        readStudent: isAdmin || checkForPermission(data, [PERMISSIONS['SIS/ReadStudent']]),
      })
    )
  } catch (error) {
    if (error?.response?.status === 401) {
      logout()
      const params = localStorageService.getDistrictSchool()
      const state = getState()
      localStorageService.clearToken()
      const app = selectApp(state)
      if (!window.location.pathname.includes('login')) {
        redirectToLogin(params, app)
      }
    }
  }
}

export const forgotPasswordCall =
  (payload, successCallback, failureCallback) => async (dispatch) => {
    try {
      const currentToken = localStorageService.getAccessToken() || {}
      const updatedPayload = {
        ...payload,
        account_id: currentToken.accountId,
        username: payload.username.trim(),
      }
      await post(API.AUTH.FORGOTPASSWORD, updatedPayload)
      dispatch(
        messageAction({
          subTitle: 'message:forgetPasswordDetailSent',
          severity: MESSAGE_SEVERITIES.SUCCESS,
        })
      )
      if (typeof successCallback === 'function') {
        successCallback()
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const redirectToLogin = (schoolParams, app) => {
  const params = !isEmpty(schoolParams) ? schoolParams : {}
  const relativePath = ROUTE().LOGIN
  window.location = params.school && app.userURL ? `${app.userURL}${relativePath}` : relativePath
}

export const logout = (successCallback, failureCallback) => async (_, getState) => {
  const currentToken = localStorageService.getAccessToken() || {}
  localStorageService.clearToken()
  localStorageService.clearDistrictSchool()
  localStorageService.clearModuleNames()
  localStorageService.clearCurrentModule()
  localStorageService.setToken({
    accountId: currentToken.accountId,
  })
  const params = localStorageService.getDistrictSchool()
  const state = getState()
  const app = selectApp(state)

  try {
    await fetch(API.AUTH.LOGOUT)
    redirectToLogin(params, selectApp(app))
    if (typeof successCallback === 'function') {
      successCallback()
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}
export const redirectToAuthGateway = (accountId) => (_, getState) => {
  localStorageService.clearModule()
  localStorageService.clearDistrictSchool()
  const state = getState()
  const app = selectApp(state)
  const redirectBase =
    process.env.NODE_ENV === 'production' ? app.redirectBase : 'http://localhost:4005'
  const relativePath = `${ROUTE().LOGIN}/auth`
  const loginUrl = `${app.baseURL}/authgateway/api/authenticate?client_id=${accountId}&redirect_uri=${redirectBase}${relativePath}`
  window.location.href = loginUrl
}

export const setAuthTokenFromLocalStorage = () => async () => {
  if (isUnauthRoute()) {
    return
  }
  const token = getTokenFromUrl()
  const currentToken = localStorageService.getAccessToken() || {}
  const authData = getAccountDataFromToken(token)
  if (isEmpty(currentToken?.accountId)) {
    localStorageService.setToken(authData)
    setBasics({
      accountId: authData?.accountId,
    })
  } else {
    localStorageService.setToken(currentToken)
    setBasics({
      accountId: currentToken?.accountId,
    })
  }
  setStorageListner()
}

export const checkForGroupPermission = (data, districtId, schoolId) => {
  if (data.isAdmin) {
    return true
  }
  const allowedActions = data?.permissions?.allowedActions || {}
  return Object.keys(allowedActions).some((action) => {
    if (action === '/') {
      return true
    }
    const spltted = action.substring(1, action.length - 1).split('/')
    if (districtId && !schoolId) {
      return spltted[0] === districtId && !spltted[1]
    }
    if (districtId && schoolId) {
      return spltted[0] === districtId || spltted[1] === schoolId
    }
  })
}
